export const RATING_BABYSITTER_EDIT_SUBMIT_REQUEST = 'rating/babysitter-edit-submit-request'
export const RATING_BABYSITTER_EDIT_SUBMIT_SUCCESS = 'rating/babysitter-edit-submit-success'
export const RATING_BABYSITTER_EDIT_SUBMIT_FAILED = 'rating/babysitter-edit-submit-failed'
